import type { TSelectedCountry } from './types'

const requiredCountry = (message: string) => (value: TSelectedCountry) =>
    value.code ? true : message

export const addressValidator = {
    address: {
        required: 'Адрес является обязательным полем',
        pattern: {
            value: /^[1-9А-ЯЁа-яеАZa-z][0-9A-ЯËa-яeA-Za-z NºN. , ()/Nº-]{1,250}$/,
            message: 'Допустимые символы: кириллица, цифры, пробел, - / . №',
        },
    },
    birthCountry: {
        validate: requiredCountry('Страна рождения является обязательным полем'),
    },
    citizenship: {
        validate: requiredCountry('Гражданство является обязательным полем'),
    },
    placeOfBirth: {
        required: 'Место рождения является обязательным полем',
    },
    residenceCountry: {
        validate: requiredCountry('Страна налогового резидентства является обязательным полем'),
    },
    isTaxResident: {
        validate: (value: string) =>
            value === 'yes' || value === 'no' ? true : 'Выбор является обязательным полем',
    },
}
